import { CSSProperties } from "react"
import cx from "classnames"
import { getCurrencyFormat } from "src/utils/string"
import "./LinkDescuento.css"

export type LinkDescuentoProps = {
    descuento: {
        total: number
        nombre: string
    }
    onOpenDescuento: () => void
    editable?: boolean
    disabled?: boolean
}

interface LinkProps extends LinkDescuentoProps {
    style?: CSSProperties
    className?: string
}

function LinkDescuento({ descuento, onOpenDescuento, editable = true, disabled = false, style = {}, className = "" }: LinkProps) {
    if (!editable && !disabled && descuento.total === 0) return null

    const isInteractive = editable && !disabled

    const valueClass = cx(
        "link-descuento__value",
        !isInteractive && !disabled ? "link-descuento__value-default" : "",
        disabled ? "link-descuento__value-disabled" : ""
    )

    return (
        <div className={cx("link-descuento", className)} style={style}>
            <span className={cx("link-descuento__label", disabled ? "link-descuento__label-disabled" : "")}>
                {descuento?.nombre || "Descuento"}
            </span>
            <span
                className={valueClass}
                onClick={isInteractive ? onOpenDescuento : undefined}
            >
                {descuento.total > 0 ? `-${getCurrencyFormat(descuento.total)}` : isInteractive || disabled ? "Agregar" : null}
            </span>
        </div>
    )
}

export default LinkDescuento